/**
 * Manage Coins.
 *
 * This creates, and updates the coins throughout the world.
 * @type {Object}
 */
Game.Utils.ManageDoors = {

	doors: [],

	tempName: '',

	/**
	 * Initialize the coin manager.
	 *
	 * @param  {Object} map_layer The Tiled layer used to store map properties.
	 * @param  {[type]} tile_id   The texture id for the tile used to display coins.
	 * @param  {[type]} layer     The layer to add the coins to.
	 */
	init: function( type, layer ) {

		var doors = Game.Utils.Map.find_objects_by_type( type, Game.Utils.Map.map, 'objects' );

		doors.forEach(
			function( door ) {

				door.y -= Game.Utils.Map.TILE_SIZE;

				var newDoor = new Game.Prefabs.Door( game, door.x, door.y, type, layer, door );
				Game.Utils.ManageDoors.doors.push( newDoor );

			}
		);

	},


	getKey: function( door ) {

		return 'door/world-1/' + Game.Utils.Map.tile_coord( door.x ) + ':' + Game.Utils.Map.tile_coord( door.y );

	},


	unlockDoor: function( name ) {

		this.tempName = name;

		this.doors.forEach(
			function( door ) {

				if ( door.name === Game.Utils.ManageDoors.tempName ) {

					door.doorTiles.forEach(
						function( tile ) {

							Game.Utils.Map.set_tile_collision( tile[0], tile[1], [ 0, 0, 0, 0 ], -1 );

						}
					);

				}

			}
		);

		this.tempName = '';

	},


	/**
	 * Reset existing coins and delete the instances.
	 *
	 * @return {[type]} [description]
	 */
	reset: function() {

		for ( var d = 0; d < this.doors.length; d++ ) {

			var door = this.doors[d];
			door.kill();

		}

		this.keys = [];

	},

};
